export function portalPath(companySlug: string, suffix = ''): string {
  const normalizedSuffix = suffix
    ? suffix.startsWith('/')
      ? suffix
      : `/${suffix}`
    : '';
  return `/portal/${companySlug}${normalizedSuffix}`;
}

export function portalSearchWithoutCredentials(search: string): string {
  const params = new URLSearchParams(search);
  params.delete('token');
  params.delete('email');
  const query = params.toString();
  return query ? `?${query}` : '';
}
